import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconStarFilled = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M8.11 8.227a1.04 1.04 0 0 0 .445-.188c.14-.11.25-.234.328-.375l2.437-5.226c.14-.297.367-.446.68-.446.313 0 .54.149.68.446l2.437 5.226c.078.14.18.266.305.375.14.094.297.156.469.188l5.46.82c.313.047.516.226.61.539.094.312.031.578-.188.797L17.79 14.46a.932.932 0 0 0-.234.398 1.2 1.2 0 0 0-.047.47l.937 5.741c.063.328-.03.586-.28.774a.71.71 0 0 1-.798.07l-4.875-2.695a.942.942 0 0 0-.492-.14.942.942 0 0 0-.492.14l-4.875 2.695a.71.71 0 0 1-.797-.07c-.25-.188-.344-.446-.281-.774l.937-5.742a.955.955 0 0 0-.023-.469.842.842 0 0 0-.258-.398l-3.984-4.078c-.22-.219-.282-.485-.188-.797.094-.313.297-.492.61-.54l5.46-.82z" }),
});

export { IconStarFilled };
